export default "/images/maccaron-app-recommend.png";